import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import * as timezonePlugin from 'dayjs/plugin/timezone';

import { getTimezoneShort } from 'utils/time';

const CURRENT_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

export const convertNylasTimestamp = (
  timestamp,
  format = 'MMM DD, YYYY',
  myTimezone,
  settings = { showTimezone: true },
) => {
  const timezone = myTimezone || CURRENT_TIMEZONE;
  const timezoneShort = getTimezoneShort(timezone);

  if (!settings.showTimezone) {
    return dayjs(timestamp * 1000).tz(timezone).format(format);
  }
  return `${dayjs(timestamp * 1000).tz(timezone).format(format)} ${timezoneShort}`;
};

export const getEmailDatetimeFormat = ({
  datePreference,
  timePreference,
}) => {
  let dateFormat = 'MMM DD, YYYY';
  if (datePreference === 'dd/mm/yyyy') {
    dateFormat = 'DD MMM YYYY';
  } else if (datePreference === 'yyyy/mm/dd') {
    dateFormat = 'YYYY-MM-DD';
  }
  let timeFormat = 'h:mmA';
  if (timePreference === '24') {
    timeFormat = 'HH:mm';
  }

  if (!timePreference) return dateFormat;
  if (!datePreference) return timeFormat;

  return `${dateFormat} ${timeFormat}`;
};
